"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CreateCustomSideNavThemeRequest () {
        return CreateCustomSideNavThemeRequest;
    },
    get SelectSideNavThemeRequest () {
        return SelectSideNavThemeRequest;
    },
    get SideNavThemeIdParam () {
        return SideNavThemeIdParam;
    },
    get UpdateCustomSideNavThemeRequest () {
        return UpdateCustomSideNavThemeRequest;
    }
});
const _zod = require("zod");
const HEX_COLOR = _zod.z.string().regex(/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/, {
    message: "Must be a 3- or 6-digit hex color, e.g. #153F6F"
});
const CreateCustomSideNavThemeRequest = _zod.z.object({
    backgroundColor: HEX_COLOR
});
const UpdateCustomSideNavThemeRequest = _zod.z.object({
    name: _zod.z.string().min(1).max(50).optional(),
    backgroundColor: HEX_COLOR.optional()
}).refine((value)=>value.name !== undefined || value.backgroundColor !== undefined, {
    message: "At least one of `name` or `backgroundColor` must be provided."
});
const SideNavThemeIdParam = _zod.z.object({
    themeId: _zod.z.string()
});
const SelectSideNavThemeRequest = _zod.z.object({
    themeId: _zod.z.string()
});
